export enum FeatureFlag {
  KUNDENACCOUNT_ANPASSEN_ENABLED = 'kundenaccount-anpassen-enabled',
  ACCOUNT_VIEW = 'account_unternehmen_overview-enable_account_view',
}
